import { useMemo } from 'react'
import { Capacitor } from '@capacitor/core'

/**
 * Platform flags for UI (push is iOS/Android native or mobile Safari/Chrome → store CTA).
 */
export function usePlatformDetection() {
  return useMemo(() => {
    const isIOSNative = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios'
    const isIOSWeb = !Capacitor.isNativePlatform() && /iPad|iPhone|iPod/i.test(navigator.userAgent)
    const isAndroidNative = Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android'
    const isAndroidWeb = !Capacitor.isNativePlatform() && /Android/i.test(navigator.userAgent)

    const showNativePushToggle = isIOSNative || isAndroidNative
    const showMobileWebStoreCta = isIOSWeb || isAndroidWeb

    /** @deprecated Use showNativePushToggle / showMobileWebStoreCta; kept for older call sites. */
    const showNotificationsToggle = showNativePushToggle || showMobileWebStoreCta
    /** @deprecated SMS removed; always false. */
    const showSmsSection = false

    return {
      isIOSNative,
      isIOSWeb,
      isAndroidNative,
      isAndroidWeb,
      showNativePushToggle,
      showMobileWebStoreCta,
      showNotificationsToggle,
      showSmsSection,
      isNative: Capacitor.isNativePlatform(),
      platform: Capacitor.getPlatform(),
    }
  }, [])
}
